'use strict';


// Tone.Buffer.on('load', function(){
//   console.log("All Tone buffers are loaded.");
//   this.ready = true;
// }.bind( this ));

var AudioSample = function(url){

  this.buffer = new Tone.Buffer( url );

}

AudioSample.prototype.play = function( dest ){
  
  var source = Tone.context.createBufferSource();
  
  source.buffer = this.buffer._buffer;
  
  source.start( 0 ); 

  if(dest)  source.connect( dest );

  return source;
}


 module.exports = AudioSample;
